import React from "react";
import "./blog-home.scss";
import BlogCard from "./blog-card";

const BlogHome = () => {
  return (
    <React.Fragment>
      <h5 className="blog-heading title-3">My Blogs</h5>
      <div className="blog-container flex-wrap">
        <BlogCard />
        <BlogCard />
        <BlogCard />

        <BlogCard />
        <BlogCard />
        <BlogCard />
      </div>
    </React.Fragment>
  );
};

export default BlogHome;
